
<template>
   <VCol class="shrink" align-self="center">
      <SBtn
          class="text-initial link-underline"
          link-small
          :to="external ? undefined : to"
          :href="external ? (to as string) : undefined"
          :target="external ? '_blank' : undefined"
          :rel="external ? 'noopener noreferrer' : undefined"
      >
        <span class="label-light text-greyedOut link-hover">{{ label }}</span>
      </SBtn>
   </VCol>
</template>

<script setup lang="ts">
import type {RouteLocationAsPathGeneric, RouteLocationAsRelativeGeneric} from "#vue-router";

interface Props {
 label: string
 to: string | RouteLocationAsRelativeGeneric | RouteLocationAsPathGeneric
 // External links bind :href (clean anchor, bypassing vue-router) + target/rel;
 // internal links keep :to. SBtn's own v-new-tab adds the localized new-tab a11y hint
 // and no-ops on internal links (it only acts on target="_blank").
 external?: boolean
}

withDefaults(defineProps<Props>(), {
  external: false
})
</script>
<style lang='scss' scoped>
.label-light {
  font-weight: 500;
  font-size: 1rem;
  line-height: 1;
}
.link-underline {
   text-decoration-color: rgb(var(--v-theme-greyedOut)) ;
}
</style>